import React from "react";
import css from "./HomeCarousel.module.css";
import Slider from "react-slick";
import "./slick-cdn.css";
import IconCollection from "../../IconCollection/IconCollection";
import { useIntl } from "../../../util/reactIntl";

const HomeCarousel = ({ reviews }) => {
  const intl = useIntl();
    
  // fallback testimonials (keeps your current visuals if reviews not passed)
  const testimonialsFallback = [
    {
      messageId: "HomeCarousel.quote1",
      author: "Marta, Amsterdam",
    },
    {
      messageId: "HomeCarousel.quote2",
      author: "Ravi & Asha",
    },
    {
      messageId: "HomeCarousel.quote3",
      author: "The Park Family, Seoul",
    },
    {
      messageId: "HomeCarousel.quote4",
      author: "Sophie, Paris",
    },
  ];

  // Helper: convert SDK reviews -> { text, author }
  const mapReviewsToSlides = (reviewsArray) => {
    if (!Array.isArray(reviewsArray) || reviewsArray.length === 0) return null;

    return reviewsArray.map((r) => {
        
      const text = r?.attributes?.content ?? r?.attributes?.description ?? "";
      const author =
        r?.author?.attributes?.profile?.displayName ??
        r?.author?.attributes?.profile?.abbreviatedName ??
        r?.author?.attributes?.displayName ??
        "Anonymous";

      return { text, author };
    });
  };

  const slides = mapReviewsToSlides(reviews) ?? testimonialsFallback;
  const PrevArrow = ({ onClick }) => (
    <button
      type="button"
      className={css.prevArrow}
      onClick={onClick}
      aria-label={intl.formatMessage({ id: 'HomeCarousel.previous' })}
    >
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="-0.5"
          y="0.5"
          width="20"
          height="20"
          transform="matrix(-1 0 0 1 20 0)"
          stroke="#223A46"
        />
        <path
          d="M13.125 15.75L7.875 10.5L13.125 5.25"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );

  const NextArrow = ({ onClick }) => (
    <button
      type="button"
      className={css.nextArrow}
      onClick={onClick}
      aria-label={intl.formatMessage({ id: 'HomeCarousel.next' })}
    >
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="0.5" y="0.5" width="20" height="20" stroke="#223A46" />
        <path
          d="M7.875 15.75L13.125 10.5L7.875 5.25"
          stroke="white"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    centerMode: true,
    centerPadding: "0px",
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          centerMode: true,
          centerPadding: "0px",
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "0px",
          dots: true,
          arrows: false,
        },
      },
    ],
  };

  return (
    <div className={css.HomeCarouselWrapper}>
      <div className={css.innerWrapper}>
        <Slider {...settings}>
          {slides.map((item, idx) => (
            <div key={idx}>
              <div className={css.card}>
                <div>
                  <div className={css.quoteIcon}>
                    <IconCollection name={"review_quote"} />
                  </div>
                  <p className={css.text}>{item.messageId ? intl.formatMessage({ id: item.messageId }) : item.text}</p>
                </div>
                <p className={css.author}>- {item.author}</p>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default HomeCarousel;
